/**
 * Loads peak images from src/assets/images/peaks/
 *
 * Single image:   ae.jpg   (original format)
 * Multiple images: ae1.jpg, ae2.jpg, ae3.jpg … (ordered by number)
 */

const images = {};

try {
  const ctx = require.context("../assets/images/peaks", false, /\.(jpg|jpeg|png|webp)$/);
  ctx.keys().forEach((key) => {
    // matches "ae.jpg" (num undefined) or "ae1.jpg" (num = "1")
    const match = key.match(/^\.\/([a-z]{2})(\d+)?\.\w+$/);
    if (match) {
      const code = match[1];
      const num = match[2] ? parseInt(match[2], 10) : 0;
      const raw = ctx(key);
      const url = typeof raw === "string" ? raw : (raw && raw.default ? raw.default : raw);
      if (!images[code]) images[code] = [];
      images[code].push({ num, url });
    }
  });
  // Sort each entry by the numeric suffix
  Object.keys(images).forEach((code) => {
    images[code].sort((a, b) => a.num - b.num);
    images[code] = images[code].map((x) => x.url);
  });
} catch (e) {
  // require.context not available (e.g. test environment)
}

export function getPeakImages(countryCode) {
  return images[countryCode.toLowerCase()] || [];
}

export function getPeakImage(countryCode) {
  const imgs = getPeakImages(countryCode);
  return imgs[0] || null;
}
